import { AppTableControls } from 'common/TableControls/TableControls';
import type { AppTableColumn } from 'shared/UI/UIKit/Table';
import type { Region } from 'services/api';

export const getRegionsTableColumns = (
  edit: (id: number) => void,
  remove: (id: number) => void,
): AppTableColumn<Region>[] => {
  const columns: AppTableColumn<Region>[] = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: ['id'],
      maxWidth: '10rem',
    },
    {
      key: 'name',
      title: 'Название региона',
      dataIndex: ['name'],
    },
  ];

  columns.push({
    key: 'controls',
    title: '',
    dataIndex: [],
    maxWidth: '10rem',
    render: (value: any, record: Region) => {
      return <AppTableControls edit={() => edit(record.id)} remove={() => remove(record.id)} />;
    },
  });

  return columns;
};
